module.exports = __webpack_public_path__ + "static/media/6.1.b6abc496.png";